import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { useContext, useEffect, useState } from 'react'
    ;
import { DataContext } from 'providers/data';
import { ParamsDataServicesPlatform } from 'utils/typeServices';

import { Box, Typography } from '@mui/material';
import NavTitle from 'components/views/NavTitle';
import HeaderSubPages from 'components/views/MyVehicles/HeaderSubPages';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    gap: 1.1875rem;
    max-width: fit-content;
    flex-direction: column;

    a, p {
        display: flex;
        font-weight: 700;
        border-radius: 5px;
        aling-items: center;
        font-size: 1.5625rem;
        color: ${theme?.palette.primary.main};
        border: 2px solid #8D9BB5;
        justify-content: space-between;
        padding: .875rem 1rem .62rem;

        svg {
            width: 25px;
            height: auto;
        }
    }

    p {
        font-size: 1rem;
        font-weight: 600;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        p {
            font-size: 1.5625rem;
            font-weight: 700;
        }

        a, p {
            padding: .875rem 1.125rem .62rem;
        }
    }
`);

const Partner = () => {
    const [listEmail, setListEmail] = useState<Array<string>>();
    const [dataServicesPlatform, setDataServicesPlatform] = useState<ParamsDataServicesPlatform>();
    const { selectedCar, dataUsefulContacts, handleGetUsefulContacts } = useContext(DataContext);

    useEffect(() => {
        if (!dataUsefulContacts) {
            handleGetUsefulContacts({ token: localStorage.getItem('token')! });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (selectedCar && dataUsefulContacts) {
            const dataServicesPlatformAux = dataUsefulContacts.ServicosPlataforma.find(({ NR_PLATAFORMA }) => selectedCar?.NR_PLATAFORMA === NR_PLATAFORMA);

            if (dataServicesPlatformAux) {
                setDataServicesPlatform(dataServicesPlatformAux);
                setListEmail(dataServicesPlatformAux.ContatosCorretor.Email.split(';'));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataUsefulContacts]);

    return (
        <HeaderSubPages>
            <Box sx={{ '#title-nav': { fontSize: '1rem' } }}>
                <NavTitle title='Parceiro' />
                <Box paddingBottom='2rem'>
                    <Typography sx={{
                        fontSize: '1.56rem',
                        color: 'secondary.main',
                        margin: '1.06rem 0',
                        fontWeight: 600
                    }}>
                        {dataServicesPlatform?.ContatosCorretor.Nome}
                    </Typography>
                    {dataServicesPlatform?.ContatosCorretor.Celular &&
                        <BoxCustom>
                            <a href={`tel:${dataServicesPlatform.ContatosCorretor.Celular}`}>
                                {dataServicesPlatform.ContatosCorretor.Celular}
                                <LocalPhoneOutlinedIcon />
                            </a>
                            {listEmail?.map((text, index) =>
                                <p key={index}>
                                    {text}
                                </p>
                            )}
                        </BoxCustom>
                    }
                </Box>
            </Box>
        </HeaderSubPages>
    );
}

export default Partner;